import { Grid } from "@mui/material";
import { AuthContext } from "core/contexts/auth/auth";
import { deleteIndexSubmittal } from "modules/agentMySecurity/services/embeddingsService";
import { useContext, useState } from "react";
import { FormContainer, FormTitle, StyledTextField, ActionButton } from "./home.styled";

function DeleteIndex() {
    const { checkAuthToken } = useContext(AuthContext);
    const [indexValue, setIndexValue] = useState("");

    const handleChange = (e) => {
        setIndexValue(e.target.value);
    };

    async function handleSubmit(e) {
        e.preventDefault();
        const token = await checkAuthToken();
        deleteIndexSubmittal(token, indexValue);
    }

    return (
        <FormContainer>
            <form id="deleteIndexForm" onSubmit={handleSubmit}>
                <FormTitle>Delete Index</FormTitle>
                <Grid container spacing={3} direction="column">
                    <Grid item>
                        <StyledTextField
                            name="indexValue"
                            label="Index Name"
                            fullWidth
                            required
                            variant="outlined"
                            value={indexValue}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <ActionButton
                            type="submit"
                            variant="contained" 
                            color="error" 
                            fullWidth
                        >
                            Delete Index
                        </ActionButton>
                    </Grid>
                </Grid>
            </form>
        </FormContainer>
    );
}

export default DeleteIndex;